/* tslint:disable */
/* eslint-disable */
/**
 * Dashboard Service
 * This is the API documentation of the Dashboard service
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ProgressRepresentation
 */
export interface ProgressRepresentation {
    /**
     * 
     * @type {number}
     * @memberof ProgressRepresentation
     */
    percent?: number;
    /**
     * 
     * @type {string}
     * @memberof ProgressRepresentation
     */
    message?: string;
}

/**
 * Check if a given object implements the ProgressRepresentation interface.
 */
export function instanceOfProgressRepresentation(value: object): value is ProgressRepresentation {
    return true;
}

export function ProgressRepresentationFromJSON(json: any): ProgressRepresentation {
    return ProgressRepresentationFromJSONTyped(json, false);
}

export function ProgressRepresentationFromJSONTyped(json: any, ignoreDiscriminator: boolean): ProgressRepresentation {
    if (json == null) {
        return json;
    }
    return {
        
        'percent': json['percent'] == null ? undefined : json['percent'],
        'message': json['message'] == null ? undefined : json['message'],
    };
}

export function ProgressRepresentationToJSON(json: any): ProgressRepresentation {
    return ProgressRepresentationToJSONTyped(json, false);
}

export function ProgressRepresentationToJSONTyped(value?: ProgressRepresentation | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'percent': value['percent'],
        'message': value['message'],
    };
}

